// extracted by mini-css-extract-plugin
export var animationContainer = "_je-0";
export var asteriskIcon = "_je-8";
export var conversationLeftSection = "_je-4";
export var conversationListItem = "_je-3";
export var conversationMiddleSection = "_je-5";
export var conversationRightSection = "_je-6";
export var detailsContent = "_je-1";
export var listContainer = "_je-7";
export var modalContent = "_je-2";